<template>
  <v-lazy transition="fade-transition">
    <div>
      <v-btn
        v-if="value.youtube_url"
        :color="color"
        :href="value.youtube_url"
        :icon="mdiYoutube"
        target="_blank"
        variant="text"
      />
      <v-btn
        v-if="value.linkedin_url"
        :color="color"
        :href="value.linkedin_url"
        :icon="mdiLinkedin"
        target="_blank"
        variant="text"
      />
      <v-btn
        v-if="value.facebook_url"
        :color="color"
        :href="value.facebook_url"
        :icon="mdiFacebook"
        target="_blank"
        variant="text"
      />
      <v-btn
        v-if="value.twitter_url"
        :color="color"
        :href="value.twitter_url"
        icon="hdx:x"
        size="small"
        target="_blank"
        variant="text"
      />
    </div>
  </v-lazy>
</template>

<script setup>
import { mdiFacebook, mdiLinkedin, mdiYoutube } from '@mdi/js'

defineProps({
  color: {
    default: '',
    type: String
  },
  value: {
    required: true,
    type: Object
  }
})
</script>
